export const renameIconStyle = {
  fill: 'rgb(129 128 128)',
};